import React from 'react';
import LeftHeader from './LeftHeader';
import LeftContent from './LeftContent';

const Left = () => (
  <aside className="w-1/2 flex flex-col border-r border-gray-300 h-screen overflow-hidden">
    <LeftHeader />
    <LeftContent />
  </aside>
);

export default Left;